import * as Styled from './styled';
import { Terms } from '~services';
import { useRequest } from 'ahooks';
import { useEffect } from 'react';

function TermsLabel() {
  const { runAsync: downloadTerm, loading: loadingTerms } = useRequest(
    Terms.download,
    {
      manual: true,
    }
  );

  const getTerms = async (tag: string) => {
    const response = await downloadTerm(tag);
    const file = new Blob([response], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    window.open(fileURL);
  };

  useEffect(() => {
    const TagHTML = document.getElementsByTagName('html');
    TagHTML[0].style.cursor = loadingTerms ? 'wait' : 'auto';
  }, [loadingTerms]);

  return (
    <Styled.Terms>
      Li e concordo com os{' '}
      <Styled.Link
        $cursor={loadingTerms}
        onClick={() => getTerms('terms_of_use')}
      >
        Termos de Uso da Conta Fretebras
      </Styled.Link>
      , como também os termos e{' '}
      <Styled.Link
        $cursor={loadingTerms}
        onClick={() => getTerms('credit_policy')}
      >
        condições de Concessão de Crédito
      </Styled.Link>{' '}
      e também com as nossas{' '}
      <Styled.Link
        $cursor={loadingTerms}
        onClick={() => getTerms('privacy_policy')}
      >
        Políticas de Privacidade FreteBras
      </Styled.Link>
      .
    </Styled.Terms>
  );
}

export default TermsLabel;
